<!-- eslint-disable vue/no-v-html -->
<template>
	<div class="project-teaser">
		<div class="project-teaser__header">
			<h5 v-if="project.title">
				{{ project.title }}
			</h5>
			<div v-else>
				Kein Titel vorhanden !!!
			</div>
		</div>
		<div class="project-teaser__image">
			<NuxtLinkLocale :to="getProjectLink(project)">
				<NuxtImg
					v-if="project['mainImage:url']"
					:src="buildAssetUrl(project['mainImage:url'])"
					:class="{ 'special-img': applySpecialClass }"
          :alt="project['mainImageMetadata']?.['alt'] || ''"
          :title="project['mainImageMetadata']?.['title'] || ''"
					loading="lazy"
          sizes="1360px"
				/>
				<NuxtImg
					v-else
					src="/images/no-image-placeholder.svg"
					class="w-100"
					alt="placeholder"
				/>
			</NuxtLinkLocale>
		</div>

  <div class="project-teaser__share">
      <SocialSharing :project="shareProject" />
		</div>
		<div v-if="project.teaser" class="project-teaser__body">
			{{ project.teaser }}
		</div>
		<div v-else>
			Kein Teaser vorhanden !!!
		</div>
		<div class="project-teaser__button mt-auto">
			<NuxtLinkLocale
				:to="getProjectLink(project)"
				class="btn btn-icon-green"
				>{{ translatedTexts.ButtonText }}</NuxtLinkLocale
			>
		</div>
	</div>
</template>
<script>
import { normalizeUrlPart } from '~/composables/useString'
import { useLocalePath } from '#imports'
import SocialSharing from "~/components/Projects/List/ProjectsListSocialSharing.vue";
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
import { getProjectRouteObject } from '~/composables/useDetailPageUrl'

export default {
	name: 'TeamDetailProjectsTeaser',
  components: { SocialSharing },
	setup() {
		const localePath = useLocalePath()
		return { localePath }
	},
	props: {
		project: {
			type: Object,
			required: true
		},
		applySpecialClass: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			translatedTexts: {
				ButtonText: ''
			}
		}
	},
	computed: {
		routeName() {
			return 'projects-details-category-title'
		},
		projectShareHref() {
			const routeObj = this.getProjectLink(this.project)
			return typeof this.localePath === 'function'
				? this.localePath(routeObj)
				: this.$router.resolve(routeObj).href
		},
		completeImageUrl() {
			const imageUrl =
				this.project.ImageFullpath || this.project['mainImage:url']
			if (!imageUrl) return null
			return this.buildAssetUrl(imageUrl)
		},
		shareProject() {
			const title = this.project?.title || this.project?.Title || ''
			const prettyUrl = this.project?.prettyUrl || this.project?.PrettyUrl || ''
			const teaser = this.project?.teaser || this.project?.Teaser || ''
			const categories = this.project?.categories || this.project?.Categories || []
			const rawImage = this.project?.ImageFullpath || this.project?.['mainImage:url'] || ''
			const image = rawImage ? this.buildAssetUrl(rawImage) : ''
      return { Title: title, PrettyUrl: prettyUrl, PublicUrlsByLocale: this.project?.PublicUrlsByLocale, Teaser: teaser, Categories: categories, ImageFullpath: image }
		}
	},
	watch: {
		'$i18n.locale': 'translateTexts'
	},
	mounted() {
		this.translateTexts()
	},
	methods: {
		getProjectLink(project) {
			return getProjectRouteObject({
				Title: project?.title,
        PrettyUrl: project?.prettyUrl,
        PublicUrlsByLocale: project?.PublicUrlsByLocale,
				Categories: project?.categories
			}, this.$i18n.locale, project?.categories?.[0]?.key)
		},
		normalizedCategoryTitle(categoryTitle) {
			return normalizeUrlPart(categoryTitle) || ''
		},
		normalizedTitle(title) {
			return normalizeUrlPart(title) || ''
		},
		translateTexts() {
			this.translatedTexts.ButtonText = this.$t('moreButtonText')
		},
		buildAssetUrl(fullpath) {
			if (!fullpath) return ''
			return usePimcoreAssetUrl(fullpath)
		}
	}
}

</script>

<style lang="scss" scoped>
.project-teaser {
	position: relative;
	margin-bottom: 5rem;
	display: flex;
	flex-direction: column;
	min-height: 85%;
	@include media-breakpoint-up(lg) {
		margin-bottom: 10.75rem;
	}
	&__header {
		@include media-breakpoint-up(lg) {
			min-height: 70px;
		}
		h5 {
			margin: 0;
		}
	}
	&__image {
		img {
			height: 400px;
			object-fit: cover;
			width: 100%;
		}
	}
	&__button {
		padding: 1rem 0;
	}
}
.full-layout {
	.project-teaser__image {
		@include media-breakpoint-up(lg) {
			img {
				height: 800px;
				width: 100%;
				object-fit: cover;
			}
		}
	}
}
</style>
